module.exports = __webpack_public_path__ + "img/ileti_app_ex.88a53604.png";